<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Shortlink</CCardHeader>

        <CCardBody>
          <!-- Description URL -->
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Destination URL"
                  class="mb-0 required"
                  :class="{ 'is-invalid': validate.destination_url.isInvalid }"
                  type="text"
                  horizontal
                  placeholder="https://masukkanlinkwebsiteanda.com"
                  :value="routesData.destination_url"
                  :description="validate.destination_url.message"
                  @input="handleTitle"
              />
            </CCol>
          </CRow>

          <!-- Shortlink -->
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Shortlink"
                  class="mb-0 required"
                  :class="{ 'is-invalid': validate.slug.isInvalid }"
                  type="text"
                  horizontal
                  placeholder="Shortlink"
                  :value="routesData.slug"
                  :description="validate.slug.message || 'Shortlink hanya boleh berisi huruf kecil (a–z), angka (0–9), dan tanda hubung (-).'"
                  @input="handleSlug"
              >
                <template #append>
                  <button
                      class="px-3 py-1.5 rounded-md bg-gray-300 text-gray-800 hover:bg-gray-400 border-0"
                      @click="handleGenerateShortSlug"
                  >
                    Generate
                  </button>
                </template>
              </CInput>
            </CCol>
          </CRow>

          <!-- Status -->
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Status"
                  :options="optionsActiveStatus"
                  required
                  horizontal
                  placeholder="Pilih status"
                  :value="routesData.status"
                  :description="validate.status.message"
                  :class="{ 'is-invalid': validate.status.isInvalid }"
                  @change="handleStatus"
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="$router.go(-1)">Back</CButton>
            </CCol>

            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="handleSave">
                Update
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>


<script>
import ShortlinkUseCase from "./app/usecase/index.js";
import RoutesUseCase from "@/views/modules/routes/app/usecase";

export default {
  name: "ProgramEdit",

  data() {
    return {
      showErrorField: false,

      id: null,

      routesData: {
        destination_url: "",
        slug: "",
        status: "active",
      },

      optionsActiveStatus: [
        { label: "ACTIVE", value: "active" },
        { label: "INACTIVE", value: "inactive" },
      ],
    };
  },

  computed: {
    validate() {
      const show = this.showErrorField;

      return {
        destination_url: {
          isInvalid: show && !this.routesData.destination_url,
          message: show && !this.routesData.destination_url ? "Description URL harus diisi" : ""
        },
        slug: {
          isInvalid: show && !this.routesData.slug,
          message: show && !this.routesData.slug ? "Shortlink harus diisi" : ""
        },
        status: {
          isInvalid: show && !this.routesData.status,
          message: show && !this.routesData.status ? "Status harus diisi" : ""
        }
      };
    }
  },

  async mounted() {
    this.id = this.$route.params.id;
    await this.loadData();
  },

  methods: {
    async loadData() {
      const { data, err } = await ShortlinkUseCase.getById(this.id);

      if (err) {
        return this.$swal.fire({ icon: "error", text: err });
      }

      if (!data) {
        return this.$swal.fire({ icon: "warning", text: "Data tidak ditemukan" });
      }

      this.routesData = {
        destination_url: data.destination_url,
        slug: data.slug,
        status: data.status,
      };
    },

    generateShortlink(maxLength = 8) {
      const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
      const allChars = chars + "-";
      const length = Math.min(maxLength, 8);

      while (true) {
        let result = "";
        for (let i = 0; i < length; i++) {
          result += allChars.charAt(Math.floor(Math.random() * allChars.length));
        }
        if (result.startsWith("-") || result.endsWith("-")) continue;
        return result;
      }
    },

    handleTitle(e) {
      this.routesData.destination_url = e?.target?.value || e;
    },

    handleSlug(e) {
      this.routesData.slug = e?.target?.value || e;
    },

    handleStatus(e) {
      this.routesData.status = e?.target?.value || e;
    },

    handleGenerateShortSlug() {
      this.routesData.slug = this.generateShortlink();
    },

    handleSave() {
      this.showErrorField = true;

      if (this.validate.destination_url.isInvalid ||
          this.validate.slug.isInvalid ||
          this.validate.status.isInvalid) {

        const messages = [
          this.validate.destination_url.message,
          this.validate.slug.message,
          this.validate.status.message,
        ].filter(Boolean);

        this.$swal.fire({
          icon: "error",
          html: `
            <h3>Terjadi kesalahan</h3>
            <ul style="text-align:left;">
              ${messages.map((e) => `<li>${e}</li>`).join("")}
            </ul>`
        });
        return;
      }

      this.processSave();
    },

    async processSave() {
      try {
        const payload = {
          ...this.routesData,
        };

        const {err} = await ShortlinkUseCase.update(this.$route.params.id, payload);

        if (err) {
          this.$swal.fire({icon: "error", text: err});
        } else {
          this.$swal.fire({icon: "success", text: "Shortlink updated"});
          this.$router.push("/management/shortlink");
        }
      } catch (error) {
        this.$swal.fire({icon: "error", text: error.message});
      }
    },

  },
};
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
@import "./Shortlink.css";
</style>
